import { Pipe, PipeTransform } from "@angular/core"

@Pipe({
    name: 'filterListByTruthyProp',
    standalone: true
})
export class FilterListByTruthyProp implements PipeTransform {
  transform<T>(list: T[], prop: keyof T, inverse = false): T[] {
    return list.filter(t => inverse ? !t[prop] : !!t[prop])
  }
}

@Pipe({
    name: 'filterOutNulls',
    standalone: true
})
export class FilterOutNulls implements PipeTransform {
  transform<T>(list: T[]): T[] {
    return list.filter(t => !!t)
  }
}